import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './Grid.module.css';
import Item from './components/Item';

const bindClasses = classNameBind.bind(styles);

const Grid = ({
  dataId,
  children,
  columnsTemplate,
  rowsTemplate,
  columnGap,
  rowGap,
  verticalAlignment,
  horizontalAlignment,
}) => (
  <div
    className={bindClasses('grid', {
      [`gap-row-${rowGap}`]: rowGap,
      [`gap-column-${columnGap}`]: columnGap,
      [`v-align-${verticalAlignment}`]: verticalAlignment,
      [`h-align-${horizontalAlignment}`]: horizontalAlignment,
    })}
    style={{
      msGridColumns: columnsTemplate,
      gridTemplateColumns: columnsTemplate,
      // When rows is not provided then create rows automatically
      ...(rowsTemplate && {
        msGridRows: rowsTemplate,
        gridTemplateRows: rowsTemplate,
      }),
    }}
    data-ppuc-id={dataId}
  >
    {React.Children.map(children, child => (
      child ? React.cloneElement(child, {
        dataId: `${dataId}.item`,
      }) : null
    ))}
  </div>
);

Grid.Item = Item;

Grid.defaultProps = {
  columnsTemplate: 'repeat(12, 1fr)',
  dataId: 'Grid',
};

export default Grid;
